import React, { useState, useEffect } from 'react';
import { Button, Table, Modal, Input, DatePicker, Row, Col } from 'antd';
import MainStepper from './MainStepper';
import { getCrewAll } from '../../services/crew';
import UnAssignDashboard from './UnAssignDashboard';

const columns = [
  {
    title: '',
    dataIndex: 'status',
    key: 'status',
    width: 30,
    render: (_, record) => {
      const needed = Number(record.numEmployees) || 0;
      const scheduled = Number(record.scheduleEmployee) || 0;
      let color = '#d9d9d9';
      if (scheduled > needed) color = '#1677ff'; // blue
      else if (scheduled < needed) color = 'red';
      else if (scheduled === needed && needed !== 0) color = '#fadb14'; // yellow
      return (
        <span>
          <span
            style={{
              display: 'inline-block',
              width: 12,
              height: 12,
              borderRadius: '50%',
              background: color,
              marginRight: 8,
              border: '1px solid #d9d9d9',
            }}
          />
        </span>
      );
    },
  },
  {
    title: 'Crew Name',
    dataIndex: 'crewName',
    key: 'crewName',
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          placeholder="Search Crew Name"
          value={selectedKeys[0]}
          onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={confirm}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={confirm}
          size="small"
          style={{ width: 90, marginRight: 8 }}
        >
          Search
        </Button>
        <Button onClick={clearFilters} size="small" style={{ width: 90 }}>
          Reset
        </Button>
      </div>
    ),
    filterIcon: filtered => <span style={{ color: filtered ? '#1677ff' : undefined }}>🔍</span>,
    onFilter: (value, record) =>
      (record.crewName || '').toString().toLowerCase().includes(value.toLowerCase()),
    render: (text, record) => {
      const needed = Number(record.numEmployees) || 0;
      const scheduled = Number(record.scheduleEmployee) || 0;
      let color = '';
      if (scheduled > needed) color = '#1677ff'; // blue
      else if (scheduled < needed) color = 'red';
      else if (scheduled === needed && needed !== 0) color = '#fadb14'; // yellow
      // fallback to default color if all are zero
      return <span >{text}</span>;
    },
  },
  {
    title: 'Event',
    dataIndex: 'eventName',
    key: 'eventName',
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          placeholder="Search Event"
          value={selectedKeys[0]}
          onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={confirm}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={confirm}
          size="small"
          style={{ width: 90, marginRight: 8 }}
        >
          Search
        </Button>
        <Button onClick={clearFilters} size="small" style={{ width: 90 }}>
          Reset
        </Button>
      </div>
    ),
    filterIcon: filtered => <span style={{ color: filtered ? '#1677ff' : undefined }}>🔍</span>,
    onFilter: (value, record) =>
      (record.eventName || '').toString().toLowerCase().includes(value.toLowerCase()),
    render: (text) => <span>{text}</span>,
  },
  {
    title: 'Supervisor',
    dataIndex: 'supervisor',
    key: 'supervisor',
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          placeholder="Search Supervisor"
          value={selectedKeys[0]}
          onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={confirm}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={confirm}
          size="small"
          style={{ width: 90, marginRight: 8 }}
        >
          Search
        </Button>
        <Button onClick={clearFilters} size="small" style={{ width: 90 }}>
          Reset
        </Button>
      </div>
    ),
    filterIcon: filtered => <span style={{ color: filtered ? '#1677ff' : undefined }}>🔍</span>,
    onFilter: (value, record) =>
      (record.supervisor || '').toString().toLowerCase().includes(value.toLowerCase()),
    render: (text) => <span>{text}</span>,
  },
  {
    title: 'Needed',
    dataIndex: 'numEmployees',
    key: 'numEmployees',
    align: 'center',
  },
  {
    title: 'Scheduled',
    dataIndex: 'scheduleEmployee',
    key: 'scheduleEmployee',
    align: 'center',
    render: (val) => (val === null ? '-' : val),
  },
  {
    title: 'Difference',
    key: 'difference',
    align: 'center',
    render: (_, record) => {
      const needed = Number(record.numEmployees) || 0;
      const scheduled = Number(record.scheduleEmployee) || 0;
      const diff = scheduled - needed;
      return diff === 0
        ? 0
        : <span>{diff}</span>;
    },
  },
  {
    title: 'No show',
    dataIndex: 'noShow',
    key: 'noShow',
    align: 'center',
  },
  {
    title: 'Venue',
    dataIndex: 'venue',
    key: 'venue',
    filterDropdown: false,
    render: (text) => <span>{text}</span>,
  },
];

function CrewDashboard() {
  const [modalOpen, setModalOpen] = useState(false);
  const [search, setSearch] = useState('');
  const [crewData, setCrewData] = useState([]);
  const [unassignModalOpen, setUnassignModalOpen] = useState(false);
  const [selectedCrew, setSelectedCrew] = useState(null);


  console.log("searchhhhh", search);  
  // Fetch crew data and log it
  useEffect(() => {
    const fetchCrewAll = async () => {
      try {
        const response = await getCrewAll();
        const crews = response.data?.data || [];
        setCrewData(crews);
        console.log('Crew data:', crews);
      } catch (error) {
        console.error('Error fetching crew data:', error);
      }
    };
    fetchCrewAll();
  }, []);

  return (
    <div style={{ background: '#fff', padding: 24, borderRadius: 8 }}>
      <Row justify="space-between" align="middle" style={{ marginBottom: 16 }}>
        <Col>
          <h2 style={{ margin: 0 }}>Crew Management</h2>
        </Col>
        <Col flex="auto" style={{ display: 'flex', justifyContent: 'center' }}>
          <Input.Search
            placeholder="Search"
            style={{ width: 320, maxWidth: '100%' }}
            value={search}
            onChange={e => setSearch(e.target.value)}
            size="large"
          />
        </Col>
        <Col>
          <Button type="primary" onClick={() => setModalOpen(true)}>
            Create Crew
          </Button>
        </Col>
      </Row>
      <Row
        gutter={16}
        align="middle"
        style={{
          marginBottom: 16,
          display: 'flex',
          justifyContent: 'space-between',
        }}
      >
        <Col >
          <DatePicker
            // value={date ? date : null}
            // onChange={(_, str) => setDate(str)}
            format="DD-MM-YYYY"
            style={{ width: 140 }}
            allowClear={false}
                      
          />
        </Col>
        
        <Col style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
          <Button style={{ marginRight: 8 }} hidden={true}>Copy Crew</Button>
          <Button danger hidden={true} />
        </Col>
      </Row>
      <Table
        columns={columns}
        dataSource={crewData.filter(row =>
          (row.crewName || '').toLowerCase().includes(search.toLowerCase()) ||
          (row.eventName || '').toLowerCase().includes(search.toLowerCase()) ||
          (row.supervisor || '').toLowerCase().includes(search.toLowerCase()) ||
          (row.venue || '').toLowerCase().includes(search.toLowerCase())
        )}
        pagination={false}
        rowSelection={{}}
        bordered={false}
        size="middle"
        style={{ background: '#E2E8F0' }}
        rowClassName={() => 'crew-table-row'}
        onRow={record => ({
          onClick: () => {
            setSelectedCrew(record);
            setUnassignModalOpen(true);
          }
        })}
      />
      <style>{`
        .crew-table-row td {
          vertical-align: middle !important;
        }
        .ant-table-thead > tr > th {
          background: #e6f7ff !important;
        }
      `}</style>
      <Modal
        open={modalOpen}
        onCancel={() => setModalOpen(false)}
        footer={null}
        width={1100}
        bodyStyle={{
          padding: 0,
          borderRadius: 16,
          overflow: 'hidden',
          background: '#f7f9fb',
          minHeight: 600,
        }}
        destroyOnClose
        centered
      >
        <div style={{ padding: 32, background: '#fff', borderRadius: 16, minHeight: 600 }}>
          <MainStepper />
        </div>
      </Modal>
      <Modal
        open={unassignModalOpen}
        onCancel={() => setUnassignModalOpen(false)}
        footer={null}
        width={1100}
        bodyStyle={{
          padding: 0,
          borderRadius: 16,
          overflow: 'hidden',
          background: '#f7f9fb',
          minHeight: 600,
        }}
        destroyOnClose
        centered
      >
        <div style={{ padding: 32, background: '#fff', borderRadius: 16, minHeight: 600 }}>
          {selectedCrew && (
            <UnAssignDashboard basicDetails={selectedCrew} />
          )}
        </div>
      </Modal>
    </div>
  );
}

export default CrewDashboard;
